import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'dcp-limited-text',
  templateUrl: './limited-text.component.html',
  styleUrls: ['./limited-text.component.scss']
})
export class LimitedTextComponent implements OnInit {

  @Input() showMoreOption = true;
  @Input() initiallyExpanded = false;
  @Input() minimumHiddenText = 20;
  isExpanded = false;
  private _charLimit = 255;
  private _fadedLineLength = 15;
  private _text = '';

  get fadedLineLength(): number {
    return this._fadedLineLength;
  }

  @Input() set fadedLineLength(value: number) {
    this._fadedLineLength = value;
    this.cdr.detectChanges();
  }

  get charLimit(): number {
    return this._charLimit;
  }

  @Input() set charLimit(value: number) {
    this._charLimit = value;
    this.cdr.detectChanges();
  }

  get text(): string {
    return this._text;
  }

  @Input() set text(text) {
    this._text = text ?? '';
    this.cdr.detectChanges();
  }

  get cropAfter(): number {
    const noHtmlText = this.replaceTagsWithSpaces(this.text);
    return noHtmlText.substring(0, this.charLimit - this.fadedLineLength).trim().length;
  }

  get visibleText() {
    return this.isTextCropped() ? this.text.substring(0, this.cropAfter) : this.text;
  }

  get fadedText() {
    return this.replaceTagsWithSpaces(this.text).substring(this.cropAfter, this.cropAfter + this.fadedLineLength);
  }

  get exceedsLimit(): boolean {
    return !!this.text && (this.text.length) > (this.charLimit + this.minimumHiddenText);
  }

  constructor(public cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.isExpanded = this.initiallyExpanded;
  }

  isTextCropped(): boolean {
    return !this.isExpanded && this.exceedsLimit;
  }

  toggleExtend(): void {
    this.isExpanded = !this.isExpanded;
  }

  /**
   * Replace tags with spaces because spaces are invisible in the html.
   * Like this the length of the texts with and without html stay the same.
   *
   * @param str string to replace the html-tags in.
   */
  replaceTagsWithSpaces(str: string): string {
    return str.replace(/(<([^>]+)>)/ig, (match) => ' '.repeat(match.length));
  }
}
